<script>
  import { fade, fly } from "svelte/transition";
  import { tourFunctions } from "../tour-functions.js";
  import { tick } from "svelte";

  let title;
  let timer;

  animateTitle();

  function getTitle() {
    let currentTitle = tourFunctions.currentScene.getTitle();
    return tourFunctions.parseContent(currentTitle);
  }

  async function animateTitle() {
    clearTimeout(timer);
    title = getTitle();
    await tick(); // make sure the title is rendered
    timer = setTimeout(() => {
      title = null; // trigger animation
    }, 5000);
  }

  function animationIn(node, params) {
    return fly(node, { y: 30, duration: 2000 });
  }

  function animationOut(node, params) {
    return fade(node, { duration: 1000 });
  }

  addEventListener("krpano:newpano", async (e) => {
    if (e.detail.scene) {
      animateTitle();
    }
  });
</script>

{#key title}
  <h1 in:animationIn out:animationOut>{@html title}</h1>
{/key}

<style>
  h1 {
    position: fixed;
    bottom: 55px;
    left: 50%;
    transform: translateX(-50%);

    z-index: 99;

    font-family: var(--font-body), sans-serif;
    font-size: 28px;
    font-weight: 500;
    color: #fff;
    text-shadow: 5px 5px 10px rgba(0, 0, 0, 0.5);
    text-align: center;
    width: 100%;
    box-sizing: border-box;
    padding: 0 1em;
  }

  /* mobile */
  @media (max-width: 768px) {
    h1 {
      font-size: 22px;
    }
  }
</style>
